<template>
  <div
    :class="[
      selected
        ? data.action === 'approve'
          ? 'border-green-500 ring-2 ring-green-500/20'
          : data.action === 'reject'
            ? 'border-red-500 ring-2 ring-red-500/20'
            : 'border-primary-500 ring-2 ring-primary-500/20'
        : data.action === 'approve'
          ? 'border-green-200 dark:border-green-800'
          : data.action === 'reject'
            ? 'border-red-200 dark:border-red-800'
            : data.stepType === 'UserStep'
              ? 'border-primary-200 dark:border-primary-800'
              : 'border-gray-200 dark:border-gray-800',
      data.action === 'approve'
        ? 'bg-green-50 dark:bg-green-950/20'
        : data.action === 'reject'
          ? 'bg-red-50 dark:bg-red-950/20'
          : data.stepType === 'UserStep'
            ? 'bg-primary-50 dark:bg-primary-950/20'
            : 'bg-white dark:bg-gray-900',
    ]"
    class="px-4 py-3 shadow-md rounded-lg border-2 w-56 transition-colors"
  >
    <Handle :position="Position.Top" class="w-3 h-3" type="target" />
    <div class="flex items-center justify-between mb-1">
      <UBadge
        :color="
          data.action === 'approve'
            ? 'green'
            : data.action === 'reject'
              ? 'red'
              : data.stepType === 'UserStep'
                ? 'primary'
                : 'neutral'
        "
        size="xs"
        variant="subtle"
      >
        {{
          data.stepType === 'UserStep'
            ? 'User Task'
            : data.stepType === 'SystemStep'
              ? 'System Task'
              : data.stepType
        }}
      </UBadge>
      <div class="flex items-center gap-1">
        <UIcon
          v-if="data.action === 'approve'"
          class="w-4 h-4 text-green-500"
          name="i-heroicons-check-circle"
        />
        <UIcon
          v-else-if="data.action === 'reject'"
          class="w-4 h-4 text-red-500"
          name="i-heroicons-x-circle"
        />
        <UIcon
          v-else-if="data.stepType === 'UserStep'"
          class="w-4 h-4 text-primary-500"
          name="i-heroicons-user"
        />
        <UIcon
          v-else-if="data.stepType === 'SystemStep'"
          class="w-4 h-4 text-orange-500"
          name="i-heroicons-cpu-chip"
        />
        <UIcon v-else class="w-4 h-4 text-gray-500" name="i-heroicons-cpu-chip" />
      </div>
    </div>
    <div class="font-bold text-gray-900 dark:text-gray-100 text-sm truncate">{{ data.name }}</div>
    <div
      v-if="data.user || data.group"
      class="text-xs text-gray-500 dark:text-gray-400 mt-1 flex items-center gap-1"
    >
      <UIcon class="w-3 h-3" name="i-heroicons-users" />
      {{ data.user || resolveGroupName(data.group) }}
    </div>
    <div
      v-if="data.action"
      :class="[
        data.action === 'approve'
          ? 'text-green-600 dark:text-green-400'
          : data.action === 'reject'
            ? 'text-red-600 dark:text-red-400'
            : 'text-orange-500',
      ]"
      class="text-[10px] font-mono mt-1 truncate"
    >
      {{ data.action }}
    </div>
    <Handle :position="Position.Bottom" class="w-3 h-3" type="source" />
  </div>
</template>

<script lang="ts" setup>
import { Handle, Position } from '@vue-flow/core'
import { useGroupNames } from '@/composables/useGroupNames'

const { resolveGroupName } = useGroupNames()

defineProps<{
  selected?: boolean
  data: {
    name: string
    stepType: string
    user?: string
    group?: string
    action?: string
  }
}>()
</script>
